<template>

    <div class="col-md-12">
        <b-overlay :show="showoverlay" rounded="sm" class="card no-shadow">
            <div class="row no-gutters">
                <div class="col-sm-5 justify-content-center my-4 px-2 rounded-left custom-employee-avatar employee-avatar ek_img_block clearfix">
                    <div role="presentation" class="nav-item align-self-center h-100 float-left ml-0">
                        <b-avatar class="m-0" variant="light" rounded button size="100%" :src="avatarsrc"></b-avatar>
                    </div>
                    <div class="employee-profile-content d-flex align-items-center float-left ml-0 pl-4">
                        <div class="employee-inner-content">
                            <div style="font-size: 24px;" class=""><h3  style="margin: 0;">{{this.public_info.name}}</h3></div>
                            <!-- <div class="text-secondary" style="overflow-wrap: break-word;">{{this.public_info.email}}</div> -->
                            <!-- <div class="mb-2 text-secondary">{{this.public_info.phone}}</div> -->
                            <div style="font-size: 12px; color: #8e8e8e !important;" class="text-secondary">{{this.public_info.jobposition}}<span v-if="this.public_info.jobposition && this.public_info.department">, </span> {{this.public_info.department}}</div>
                            <div class="staff-id">Employee Code : {{this.public_info.employee_code}}</div>
                            <div style="font-size: 12px; color: #8e8e8e !important;" class="text-secondary" v-if="this.public_info.date_of_joining != ''">Date of Join : {{this.public_info.date_of_joining | formatDate}}</div>
                        </div>
                    </div>
                </div>
                <div class="justify-content-center m-0 p-4 rounded-left custom-employee-avatar employee-avatar clearfix" :class="is_ess != 'yes' ? 'col-sm-4' : 'col-sm-7'">
                    <ul class="personal-info">
                        <li v-if="this.public_info.email != ''">
                            <div class="title">Email:</div>
                            <div class="text"><a href="">{{this.public_info.email}}</a></div>
                        </li>
                        <li v-if="this.public_info.date_of_birth != ''">
                            <div class="title">Birthday:</div>
                            <div class="text">{{this.public_info.date_of_birth}}</div>
                        </li>
                        <li v-if="this.public_info.address != ''">
                            <div class="title">Address:</div>
                            <div class="text">{{this.public_info.address}}</div>
                        </li>
                        <li v-if="this.public_info.gender != ''">
                            <div class="title">Gender:</div>
                            <div class="text">{{this.public_info.gender}}</div>
                        </li>
                    </ul>
                </div>


                <div class="col-sm-3 pr-3 position-relative">

                    <!-- alpha fix removed style="bottom: 1.5rem; right: 20px;" and class position-absulate and added mt-3 -->
                    <div class="text-right mt-3"  v-if="is_ess != 'yes'">
                        <a :href="$api_url+'/loan-advance/applications'" class="btn btn-primary rounded p-2 pr-4 pl-4"><span><b-icon icon="reply" rotate="0" flip-h="" class="mr-2" scale="2"></b-icon></span><span>Back to Applications</span></a>
                    </div>


                </div>
               <!--<div class="col-sm-3 justify-content-end d-flex align-items-center pr-3">
                    <a :href="$api_url+'/loan-advance'" class="btn btn-primary rounded p-2 pr-4 pl-4"><span><b-icon icon="reply" rotate="0" flip-h="" class="mr-2" scale="2"></b-icon></span><span>Back to List</span></a>
                </div> -->
            </div>
        </b-overlay>
    </div>
</template>

<script>
    import moment from 'moment';
    export default{

        mounted() {

            this.showoverlay = false;
        },
        props: ['employee_id','is_ess'],
        data(){

            return {

                public_info : [],
                avatarsrc : '',

                showoverlay : true,

                show_status : false,

            }
        },
        filters:{
            formatDate: function(value){
                if (value && value != '0000-00-00 00:00:00') {
                    return moment(String(value)).format('YYYY/MM/DD')
                }else{
                    value = '';
                }
            },
        },
        methods:{
            getEmployeePublicData: function()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/employee/publicinfo' , {
                    params: {
                        id:this.employee_id
                    }
                }).then(function(response){
                    this.public_info = response.data;

                    if(this.public_info.pic != '')
                        this.avatarsrc = this.$api_url+'/avatar/'+ this.public_info.company_id + '/' + this.public_info.pic;
                    else
                        this.avatarsrc = this.$api_url+'/avatar/demo.jpg';

                    if(this.public_info.status == 1) this.employee_status = true;

                    this.show_status = true;

                }.bind(this));
            },


        },
        created: function(){
            this.getEmployeePublicData();
        }
    }
</script>
